import styled from "styled-components"
import variables from './variables'

export const ParagraphDaintree = styled.p`
  font-family: montserrat, sans-serif; 
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  margin-bottom: 20px;
`

export const Heading1Red = styled.h1`
  color: ${variables.colors.torchRed};
  font-family: obvia-wide, sans-serif;
  font-weight: 900;
  font-style: normal;
  font-size: 72px;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
  max-width: 1000px;

  @media (max-width: 575.98px) {
    font-size: 46px;
    line-height: 54px;
  }
`

export const Heading1White = styled(Heading1Red)`
  color: ${variables.colors.catskillWhite};
`

export const Heading1Daintree = styled(Heading1Red)`
  color: ${variables.colors.daintree};
`

export const Heading3 = styled.h3`
  color: ${variables.colors.torchRed};
  font-family: obvia-wide, sans-serif; 
  font-weight: 800;
  font-style: normal;
  text-align: center;
  margin-bottom: 40px;
  width: 100%;
`

export const UnordedList = styled.ul`
  font-family: montserrat, sans-serif; 
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  margin-bottom: 20px;
`


export const Wrapper = styled.section`
  position: relative;
  width: 100%;
`

export const WrapperBlack = styled(Wrapper)`
  background-color: black;
`

export const WrapperLight = styled(Wrapper)`
  background-color: ${variables.colors.catskillWhite};
`

export const WrapperWhite = styled(Wrapper)`
  background-color: white;
`

export const WrapperRed = styled(Wrapper)`
  background-color: #FF3C67;
`

export const WrapperTorchRed = styled(Wrapper)`
  background-color: ${variables.colors.torchRed};
`

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding-left: 4rem;
  padding-right 4rem;

  @media (max-width: 575.98px) {
    padding-left: 2rem;
    padding-right 2rem;
  }
`

export const HandleImageWidth = styled.div`
  width: 337px;

  @media (max-width: 575.98px) {
    width: 100%;
  }
`

export const HandleImageWidthXSmall = styled.div`
  width: 100px;
`

export const HandleImageWidthSmall = styled.div`
  width: 200px;
`

export const HandleImageWidthLarge = styled.div`
  width: 640px;

  @media (max-width: 575.98px) {
    width: 100%;
  }
`
export const HandleImageWidthXLarge = styled.div`
  width: 768px;

  @media (max-width: 575.98px) {
    width: 100%;
  }
`

export const Row = styled.div`
  display: flex;

  @media (max-width: 575.98px) {
    display: block;
  }
`

export const Col6 = styled.div`
  flex: 1;
`

export const Col6WithPadding = styled(Col6)`
  padding-top: 7rem;
  padding-right: 4rem;
  padding-bottom: 7rem;
  padding-left: 4rem;

  @media (max-width: 575.98px) {
    padding: 7rem 2rem 7rem 2rem;
  }
`

export const Col12 = styled.div`
  flex: 100%;
`

export const Col6Left = styled(Col6)`
  background-color: white;
`

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
`

export const DotsVertical = styled(Dots)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  position: absolute;
  margin-top: -65px;
`

export const Dot = styled.div`
  background-color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 20px;

  &:nth-of-type(1) {
    background-color: ${variables.colors.catskillWhite};
  }

  &:nth-of-type(2) {
    background-color: ${variables.colors.torchRed};
  }

  &:nth-of-type(3) {
    background-color: ${variables.colors.daintree};
  }
`

export const DotVertical = styled(Dot)`
  margin-right: 0;
  margin-bottom: 20px;

  &:nth-of-type(3) {
    margin-bottom: 0;
  }
`

export const Label = styled.div`
  font-family: montserrat, sans-serif; 
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  width: 100%;
  display: block;
  margin-top: 40px;
  padding-left: 2em;

  @media (max-width: 575.98px) {
    position: absolute;
  }
`

export const LabelLight = styled(Label)`
  color: ${variables.colors.catskillWhite};
`

export const LabelDark = styled(Label)`
  color: ${variables.colors.daintree};
`

export const LabelRight = styled(LabelLight)`
  text-align: right;
  padding-right: 2em;
`

export const LabelDarkRight = styled(LabelRight)`
  color: ${variables.colors.daintree};
`
